import _extends from "@babel/runtime/helpers/extends";
import * as React from 'react';
import cx from 'classnames';
import { ControlInputContainer } from '../../../internal/components/ControlInputContainer';
import { useDeviceType } from '../../../responsive';
import { getStyles } from './styles';
var SwitchComponent = /*#__PURE__*/React.forwardRef(function Switch(props, ref) {
  var disabled = props.disabled,
    invalid = props.invalid,
    label = props.label;
  var deviceType = useDeviceType();
  var styles = getStyles(deviceType);
  return /*#__PURE__*/React.createElement(ControlInputContainer, _extends({}, props, {
    type: "checkbox",
    className: cx(styles['switch'], disabled && styles['disabled'], invalid && styles['invalid']),
    ref: ref
  }), /*#__PURE__*/React.createElement("span", {
    className: styles['indicator']
  }), label && /*#__PURE__*/React.createElement("span", {
    className: styles['label']
  }, label));
});

/**
 * Компонент простого чекбокса с лейблом
 *
 * На телефоне имеет блочный дизайн и чекбокс справа
 *
 * @export
 * @param {ICheckboxProps} props
 * @returns
 */
export var Switch = /*#__PURE__*/React.memo(SwitchComponent);